/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
export enum ProcessPageType {
  ALL_RUNS = 'all_runs',
  LEARNINGS = 'learnings',
  SCHEDULES = 'schedules',
  EXCEPTIONS = 'exceptions',
  OUTPUTS = 'outputs'
}

export const PROCESS_INFO_PAGES_MAP = {
  [ProcessPageType.ALL_RUNS]: {
    key: 'all_runs',
    pagePath: 'run/all',
    title: 'Runs'
  },
  [ProcessPageType.LEARNINGS]: {
    key: 'learnings',
    pagePath: 'learnings',
    title: 'Learnings'
  },
  [ProcessPageType.SCHEDULES]: {
    key: 'schedules',
    pagePath: 'schedules',
    title: 'Schedules'
  },
  [ProcessPageType.EXCEPTIONS]: {
    key: 'exceptions',
    pagePath: 'exceptions',
    title: 'Exceptions'
  },
  [ProcessPageType.OUTPUTS]: {
    key: 'outputs',
    pagePath: 'outputs',
    title: 'Outputs'
  }
};

const extraPaths = ['runs'];

export const processInfoPages = Object.values(PROCESS_INFO_PAGES_MAP);

const pagePaths = Object.values(processInfoPages).map((i) => i.pagePath);

export const processInfoPageUrlPaths = [...pagePaths, ...extraPaths];
